import { useState } from "react";
import { TFilters } from "../../../../../components/TableDataGridV2/types";
import { Box, Button, Container, Grid, TextField } from "@mui/material";
import SelectCultura from "../../../../../components/SelectsSimpleApiQuery/SelectCultura";
import SelectAgrotoxico from "../../../../../components/SelectsSimpleApiQuery/SelectAgrotoxico";

export default function PreFiltros({
                                       filtros,
                                       onSubmitFilters
                                   }: PreFiltrosProps) {
    const [internFilters, setInternFilters] = useState<TFilters>(filtros || {});

    const handleInsertFiltros = (prop: string, value: any) => {
        setInternFilters(prevState => ({ ...prevState, [prop]: value }))
    };

    const filtrarObj = (obj: TFilters) => {
        const novoObjeto: Record<string, any> = { ...obj };
        Object.keys(novoObjeto).forEach((key) => {
            if (key.startsWith('cultura')) {
                if (typeof novoObjeto[key] === 'string') {
                    novoObjeto['cultura_id_contem[]'] = novoObjeto[key]
                        .split(',')
                        .map((id: any) => parseInt(id.trim(), 10));
                } else if (Array.isArray(novoObjeto[key])) {
                    novoObjeto['cultura_id_contem[]'] = novoObjeto[key].map((item: any) => item.id);
                } else {
                    novoObjeto['cultura_id_contem[]'] = [novoObjeto[key].id];
                }
                delete novoObjeto[key];
            }
            if (key.startsWith('agrotoxico')) {
                if (typeof novoObjeto[key] === 'string') {
                    novoObjeto['agrotoxico_id_contem[]'] = novoObjeto[key]
                        .split(',')
                        .map((id: any) => parseInt(id.trim(), 10));
                } else if (Array.isArray(novoObjeto[key])) {
                    novoObjeto['agrotoxico_id_contem[]'] = novoObjeto[key].map((item: any) => item.id);
                } else {
                    novoObjeto['agrotoxico_id_contem[]'] = [novoObjeto[key].id];
                }
                delete novoObjeto[key];
            }
        });

        return novoObjeto;
    };

    const handleSubmit = () => {
        const formatValue = filtrarObj(internFilters || {})
        onSubmitFilters(formatValue)
    };

    return (
        <Container maxWidth="md" sx={{ py: 2 }}>
            <Grid container spacing={2}>
                {/* Ordem conforme banco de dados */}
                <Grid size={{xs: 12, md: 6}}>
                    <TextField
                        label="Código da Prescrição"
                        variant="outlined"
                        type="number"
                        fullWidth
                        onChange={(e) => {
                            handleInsertFiltros("id", e.target.value);
                        }}
                    />
                </Grid>
                <Grid size={{xs: 12, md: 6}}>
                    <SelectAgrotoxico
                        value={internFilters.agrotoxico ?? []}
                        onChange={(agrotoxico) => handleInsertFiltros("agrotoxico", agrotoxico)}
                    />
                </Grid>
                <Grid size={{xs: 12, md: 6}}>
                    <SelectCultura
                        value={internFilters.cultura ?? []}
                        onChange={(cultura) => handleInsertFiltros("cultura", cultura)}
                    />
                </Grid>
                <Grid size={{xs: 12, md: 6}}>
                    <TextField
                        label="Qtd. Aplicações"
                        variant="outlined"
                        type="number"
                        fullWidth
                        onChange={(e) => {
                            handleInsertFiltros("quantidade_aplicacoes", e.target.value);
                        }}
                    />
                </Grid>
                <Grid size={{xs: 12, md: 6}}>
                    <TextField
                        label="Intervalo Aplicações (dias)"
                        variant="outlined"
                        type="number"
                        fullWidth
                        onChange={(e) => {
                            handleInsertFiltros("dias_intervalo_aplicacoes", e.target.value);
                        }}
                    />
                </Grid>
                <Grid size={{xs: 12, md: 6}}>
                    <TextField
                        label="Dias de Carência"
                        variant="outlined"
                        type="number"
                        fullWidth
                        onChange={(e) => {
                            handleInsertFiltros("dias_carencia", e.target.value);
                        }}
                    />
                </Grid>
                <Grid size={{xs: 12, md: 6}}>
                    <TextField
                        label="Complemento"
                        variant="outlined"
                        fullWidth
                        onChange={(e) => {
                            handleInsertFiltros("complemento", e.target.value);
                        }}
                    />
                </Grid>
                <Grid size={{xs: 12, md: 6}}>
                    <TextField
                        label="Modo de Aplicação"
                        variant="outlined"
                        fullWidth
                        onChange={(e) => {
                            handleInsertFiltros("modo_aplicacao", e.target.value);
                        }}
                    />
                </Grid>
                <Grid size={{xs: 12, md: 6}}>
                    <TextField
                        label="Época de Aplicação"
                        variant="outlined"
                        fullWidth
                        onChange={(e) => {
                            handleInsertFiltros("epoca_aplicacao", e.target.value);
                        }}
                    />
                </Grid>
                <Grid size={{xs: 12, md: 6}}>
                    <TextField
                        label="Manejo"
                        variant="outlined"
                        fullWidth
                        onChange={(e) => {
                            handleInsertFiltros("manejo", e.target.value);
                        }}
                    />
                </Grid>
                <Grid size={{xs: 12, md: 6}}>
                    <TextField
                        label="Grupo Químico"
                        variant="outlined"
                        fullWidth
                        onChange={(e) => {
                            handleInsertFiltros("grupo_quimico", e.target.value);
                        }}
                    />
                </Grid>
                <Grid size={{xs: 12, md: 6}}>
                    <TextField
                        label="Formulação"
                        variant="outlined"
                        fullWidth
                        value={internFilters?.formulacao ?? ""}
                        onChange={(e) => {
                            handleInsertFiltros("formulacao", e.target.value);
                        }}
                    />
                </Grid>
            </Grid>
            <Box mt={2}>
                <Button
                    variant="contained"
                    onClick={handleSubmit}
                >
                    Pesquisar
                </Button>
            </Box>
        </Container>
    );
}

interface PreFiltrosProps {
    filtros?: TFilters;
    onSubmitFilters: (args: TFilters) => void;
}